module.exports = __webpack_public_path__ + "img/logo.655ea868.png";